import {obj_deepCopy_f, obj_forEach_f, obj_size_fn} from "../../../functions/src/shareCode/Share_S_Obj";
import {
    validator_array_fb,
    validator_arrayObj_fb,
    validator_boolean_fb,
    validator_function_fb,
    validator_null_fb,
    validator_number_double_fb,
    validator_number_fb,
    validator_obj_fb,
    validator_objEmpty_fb,
    validator_string_fb
} from "../../../functions/src/shareCode/Share_S_Validator";
import {
    enum_loginErrors, enum_httpCodes,
    enum_loginMethods,
    enum_questTypes,
    enum_subCollection_teamStatus, enum_questLocationsTypes_s, enum_serverEndPoints, enum_serverChildrenNames
} from "../../../functions/src/shareCode/Share_S_Enum";
import {
    serverLocalStorage_dataChange_f, serverLocalStorage_dataChange_multiData_f,
    serverLocalStorage_getDataOnce_f,
    serverLocalStorage_listener_add_f,
    serverLocalStorage_listener_establishConnection_f,
    serverLocalStorage_listener_remove_f
} from "./S_ServerLocalStorage";

import {
    date_clearTimeout,
    date_doOnlyOnce_fn,
    date_newDate_fd,
    date_removeInterval,
    date_setInterval,
    date_setTimeout
} from "../S_Date";
import {
    store_getStateValue_vo,
    store_listener_remove_f,
    store_listener_set_f,
    store_setStateValue,
    store_var
} from "@/store";
import {
    FB_FbAuth, FB_LocalStorageUpdateMulti,
    FB_QuestExplore,
    FB_QuestExplore_Metadata, FB_UserDataSub_OnlineUser, FB_File
} from "../../../functions/src/shareCode/Share_S_Classes";
import {date_nowTime_t} from "../../../functions/src/shareCode/Share_S_Date";
import {file_getFileBlobFromBlobUrl_f} from "@/scripts/S_Files";
import {gv_FbConfig} from "@/scripts/S_GlobalVar";
import {str_parseString_fs} from "@/scripts/S_str";



// ============== variable private ======================

// urls_o
const urls_o = {

    // https://identitytoolkit.googleapis.com/v1/
    signInWithPassword  : `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword`,
    signUp              : `https://identitytoolkit.googleapis.com/v1/accounts:signUp`,
    signInWithIdp       : `https://identitytoolkit.googleapis.com/v1/accounts:signInWithIdp`,
    signInWithPhoneNumber: `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPhoneNumber`,
    sendVerificationCode: `https://identitytoolkit.googleapis.com/v1/accounts:sendVerificationCode`,
    update              : `https://identitytoolkit.googleapis.com/v1/accounts:update`,
    createAuthUri       : `https://identitytoolkit.googleapis.com/v1/accounts:createAuthUri`,
    sendOobCode         : `https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode`,
    recaptchaParams     : `https://identitytoolkit.googleapis.com/v1/recaptchaParams`,

    token               : `https://securetoken.googleapis.com/v1/token`,
    firebasestorage     : `https://firebasestorage.googleapis.com/v0/b/`,

    // translation
    url_translate           : `https://translation.googleapis.com/language/translate/v2`,
    url_detectLang          : `https://translation.googleapis.com/language/translate/v2/detect
`,
}

// socketData_byDatabaseUrl_o
const socketData_byDatabaseUrl_o = {}

// https_methods
const https_methods = {
    POST    : "POST",
    GET     : "GET",
    PATCH   : "PATCH",
    PUT      : "PUT",
    DELETE   : "DELETE",
}

// urlSuffix_os
const urlSuffix_os = {
    database_json : ".json"
}

// http_firestore_types
const http_firestore_types = {
    nullValue     : "nullValue",
    booleanValue  : "booleanValue",
    integerValue  : "integerValue",
    doubleValue   : "doubleValue",
    timestampValue: "timestampValue",
    stringValue   : "stringValue",
    bytesValue    : "bytesValue",
    referenceValue: "referenceValue",
    geoPointValue : "geoPointValue",

    arrayValue    : "arrayValue",

    mapValue        : "mapValue"

}

// http_headers
const http_headers = {
    requestETag     : "X-Firebase-ETag",
    responseETag    : "ETag",
    checkETag       : "if-match",

}

// socketsMessageTypes_es
const socketsMessageTypes_es = {
    info : "c",
    data : "d"
}

// socketAction
const socketAction = {
    auth            : "auth",
    firebaseVersion : "s",
    query           : "q",
    stopListening   : "n",
    onDisconnect    : "o",

    // not using
    put             : "p",
    merge           : "m",
    unauth          : "unauth",

}

// http_numbers_on
const http_numbers_on = {
    retryFailedRequestNum : 3,
    retrySendFailedRequestTime : 20 * 1000, // 
    retrySendFailedRequestInitTime : 3 * 1000, // 
    retryFailedMsgWaitTime : 500, 
    retryFailedMsgNum : 5, 
    retryToOpenWebSocketTime : 1000, 
    keepAliveTimeout : 10*1000,
}




// ============== vars public ======================

// http_endPointPath_oa
export const http_endPointPath_oa = {

    DATABASE_MAIN                           : [gv_FbConfig().databaseURL],
    DATABASE_ONGOING                        : [gv_FbConfig().databaseURL_ongoing],

    // database main
    PRE_CURRENT_VERSION                     : [gv_FbConfig().databaseURL, "PRE_CURRENT_VERSION"],
    DATABASE_MAIN_TQ_INFO                   : [gv_FbConfig().databaseURL, "PRE_TQ_INFO"],
    DATABASE_STORE_CHAT                     : [gv_FbConfig().databaseURL, "STORE_CHAT"],
    DATABASE_STORE_CHAT_MESSAGES            : [gv_FbConfig().databaseURL, "STORE_CHAT_MESSAGES"],
    STORE_CHAT_CREATOR_MESSAGE              : [gv_FbConfig().databaseURL, "STORE_CHAT_CREATOR_MESSAGE"],
    DATABASE_MAIN_USERS_DATA                : [gv_FbConfig().databaseURL, "PRE_USERS_DATA"],
    QUESTS_TICKETS                          : [gv_FbConfig().databaseURL, "QUESTS_TICKETS"],
    DATABASE_MAIN_QUESTS_TICKETS            : [gv_FbConfig().databaseURL, "PRE_TICKET_SHORT_KEY"],
    QUESTS_EVENTS                           : [gv_FbConfig().databaseURL, "QUESTS_EVENTS"],
    QUESTS_MOLDS                            : [gv_FbConfig().databaseURL, "QUESTS_MOLDS"],
    QUESTS_QUESTS_GEO_HASH                  : [gv_FbConfig().databaseURL, "QUESTS_GEO_HASH"],
    DATABASE_MAIN_QUESTS_EXPlORE_INFO       : [gv_FbConfig().databaseURL, "PRE_QUESTS_EXPlORE_INFO"],
    DATABASE_MAIN_QUESTS_BACKUP_INFO        : [gv_FbConfig().databaseURL, "PRE_QUESTS_BACKUP_INFO"],
    DATABASE_MAIN_FORUMS_DATA               : [gv_FbConfig().databaseURL, "PRE_FORUMS_DATA"],
    DATABASE_MAIN_CREATORS_FILES            : [gv_FbConfig().databaseURL, "PRE_QUESTS_FILES"],

    PRE_QUESTS_REVIEWS                      : [gv_FbConfig().databaseURL, "PRE_QUESTS_REVIEWS"],
    PRE_LAST_QUEST_REVIEWS_POINTERS         : [gv_FbConfig().databaseURL, "LAST_QUEST_REVIEWS_POINTERS"],
    DATABASE_PRE_QUESTS_DISCOUNT_COUPONS    : [gv_FbConfig().databaseURL, "PRE_QUESTS_DISCOUNT_COUPONS"],
    DATABASE_PRE_REPORTS_REVIEWS            : [gv_FbConfig().databaseURL, "PRE_REPORTS_REVIEWS"],

    DATABASE_PRE_MORE_INFO                  : [gv_FbConfig().databaseURL, "PRE_MORE_INFO"],
    DATABASE_PRE_FEATURES_MORE_INFO         : [gv_FbConfig().databaseURL, "PRE_FEATURES_MORE_INFO"],
    DATABASE_GLOBAL_VERSION_INFO            : [gv_FbConfig().databaseURL, "GLOBAL_VERSION_INFO"],

    DATABASE_MAIN_ERRORS                    : [gv_FbConfig().databaseURL, "PRE_ERRORS"],

    PUDSC_QUESTS_TICKETS                    : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "QUESTS_TICKETS"],
    PUDSC_CREATOR_MONTHLY_TICKETS           : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "CREATOR_MONTHLY_TICKETS"],
    PUDSC_MORE_INFO                         : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "MORE_INFO"],
    PUDSC_CREDIT_CARD                       : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "CREDIT_CARD"],
    PUDSC_CREATOR_PAYMENT_INFO              : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "CREATOR_PAYMENT_INFO"],
    PUDSC_SUBSCRIPTION_PLAN_INFO            : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION_SUBSCRIPTION_PLAN_INFO],
    PUDSC_LOVED_QUESTS                      : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "LOVED_QUESTS"],
    PUDSC_CREATED_QUESTS                    : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "CREATED_QUESTS"],
    PUDSC_QUESTS_PERMISSIONS                : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "QUESTS_PERMISSIONS"],
    PUDSC_ONLINE_USERS                      : [gv_FbConfig().databaseURL, enum_serverChildrenNames.PRE_USERS_DATA_SUB_COLLECTION, "ONLINE_USERS"],
    PUDSC_CURRENT_TIME                      : [gv_FbConfig().databaseURL, ".info", "serverTimeOffset"],

    // database ongoing
    DATABASE_ONGOING_TEAM_PLAYER_GEO_LOCATIONS  : [gv_FbConfig().databaseURL_ongoing, "TEAM_PLAYER_GEO_LOCATIONS"],
    DATABASE_ONGOING_ONGOING_PLAYER_MORE_INFO   : [gv_FbConfig().databaseURL_ongoing, "ONGOING_PLAYER_MORE_INFO"],
    DATABASE_ONGOING_QUESTS_CHATS               : [gv_FbConfig().databaseURL_ongoing, "QUESTS_CHATS"],
    DATABASE_ONGOING_GAME_STATUS                : [gv_FbConfig().databaseURL_ongoing, "GAME_STATUS"],
    DATABASE_ONGOING_TEAMS_STATUS               : [gv_FbConfig().databaseURL_ongoing, "TEAMS_STATUS"],
    DATABASE_ONGOING_SIDE_MISSIONS_STATUS       : [gv_FbConfig().databaseURL_ongoing, "SIDE_MISSIONS_STATUS"],
    DATABASE_ONGOING_TSS_MAP_MISSIONS           : [gv_FbConfig().databaseURL_ongoing, "ONGOING_TEAMS_STATUS_SUBCOLLECTION", "MAP_MISSIONS"],
    DATABASE_ONGOING_TSS_MAP_LAST_MISSIONS      : [gv_FbConfig().databaseURL_ongoing, "ONGOING_TEAMS_STATUS_SUBCOLLECTION", "MAP_LAST_MISSIONS"],
    DATABASE_ONGOING_TSS_CARDS_MISSIONS         : [gv_FbConfig().databaseURL_ongoing, "ONGOING_TEAMS_STATUS_SUBCOLLECTION", "CARDS_MISSIONS"],
    DATABASE_ONGOING_TSS_MISSIONS_RIDDLES       : [gv_FbConfig().databaseURL_ongoing, "ONGOING_TEAMS_STATUS_SUBCOLLECTION", "MISSIONS_RIDDLES"],
    DATABASE_ONGOING_TSS_MISSIONS_LAST_RIDDLES  : [gv_FbConfig().databaseURL_ongoing, "ONGOING_TEAMS_STATUS_SUBCOLLECTION", "MISSIONS_LAST_RIDDLES"],
    DATABASE_ONGOING_SAVED_MESSAGES             : [gv_FbConfig().databaseURL_ongoing, "ONGOING_SAVED_MESSAGES"],

    // firestore
    FIRESTORE_QUESTS_EXPLORE: [gv_FbConfig().storage_doc, "QUESTS_EXPLORE"],
    FIRESTORE_ADMIN_EMAILS  : [gv_FbConfig().storage_doc, "ADMIN_EMAILS"],
    FIRESTORE_ADMIN_CREATOR_MONTHLY_PAYMENT_SUMMARY : [gv_FbConfig().storage_doc, "ADMIN_CREATOR_MONTHLY_PAYMENT_SUMMARY"],
    FIRESTORE_CARDS_BODY    : [gv_FbConfig().storage_doc, "CARDS_BODY"],
    FIRESTORE_OPEN_MAP_BODY : [gv_FbConfig().storage_doc, "OPEN_MAP_BODY"],
    FIRESTORE_MISSIONS_BODY : [gv_FbConfig().storage_doc, "MISSIONS_BODY"],
    FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_CARDS         : [gv_FbConfig().storage_doc, "CARDS_BODY"],
    FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_OPEN_MAP_BODY : [gv_FbConfig().storage_doc, "OPEN_MAP_BODY"],
    FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_MISSIONS_BODY : [gv_FbConfig().storage_doc, "MISSIONS_BODY"],

    // functions
    FUNCTIONS_endPoint_questTicket_new          : [gv_FbConfig().functions, 'endPoint_questTicket_new'],
    FUNCTIONS_endPoint_questTicket_edit         : [gv_FbConfig().functions, 'endPoint_questTicket_edit2'],
    FUNCTIONS_endPoint_chargeTicket             : [gv_FbConfig().functions, 'endPoint_chargeTicket'],
    FUNCTIONS_endPoint_sendEmail                : [gv_FbConfig().functions, 'endPoint_sendEmail'],
    FUNCTIONS_endPoint_updateUserAccessLevel    : [gv_FbConfig().functions, 'endPoint_updateUserAccessLevel'],
    FUNCTIONS_endPoint_icredit_GetUrl  : [gv_FbConfig().functions, 'endPoint_icredit_GetUrl'],
    FUNCTIONS_endPoint_icredit_chargeSimple_refund  : [gv_FbConfig().functions, 'endPoint_icredit_chargeSimple_refund'],
    FUNCTIONS_endPoint_chargePayment  : [gv_FbConfig().functions, 'endPoint_chargePayment'],
    FUNCTIONS_endPoint_runMonthSummaryByDate_s  : [gv_FbConfig().functions, 'endPoint_runMonthSummaryByDate_s'],
    FUNCTIONS_endPoint_subscriptionCharge  : [gv_FbConfig().functions, enum_serverEndPoints.endPoint_subscriptionCharge],

    // storage
    STORAGE_USERS_DRIVE : [gv_FbConfig().storageBucket, "USERS_DRIVE"],
    STORAGE_USERS_DATA  : [gv_FbConfig().storageBucket, "USERS_DATA"],
    STORAGE_TEAMS_STATUS : [gv_FbConfig().storageBucket_belgium, "TEAMS_STATUS"]
}

// http_endPointPath_oa
export const http_classSubChildName_os = {
    qr_reviewerId_uid: "qr_reviewerId_uid",
    qr_timestamp_t: "qr_timestamp_t",

    qetp_orderBy_uid: "qetp_orderBy_uid",
    qex_creatorId_uid: "qex_creatorId_uid",
    qex_metadata_c: "qex_metadata_c",
    qexm_active_b: "qexm_active_b",

    qt_status_e: "qt_status_e",
    qt_saleDate_t: "qt_saleDate_t",

    ba_active_b: "ba_active_b",

    ud_email_s: "ud_email_s",

    udsqp_questId_uid: "udsqp_questId_uid",
    udsqp_questType_e: "udsqp_questType_e",
    udsqp_userId_uid: "udsqp_userId_uid",

    rr_status_e: "rr_status_e",
}

// fbRef_subRef
export const fbRef_subRef = {
    rs_unlock_byLockId_c: "rs_unlock_byLockId_c",
    rs_riddleId_n: "rs_riddleId_n",
    rs_startMissionTime_t: "rs_startMissionTime_t",

    qt_playersJoinDate_byUserId_t: "qt_playersJoinDate_byUserId_t",
    qt_saleDate_t: "qt_saleDate_t",

    qev_startingDate_t: "qev_startingDate_t",

    ts_finishRiddles_byRiddleId_b: "ts_finishRiddles_byRiddleId_b",
    ts_finishLastRiddles_byRiddleId_b: "ts_finishLastRiddles_byRiddleId_b",
    ts_finishMissionsRiddles_byRiddleId_b: "ts_finishMissionsRiddles_byRiddleId_b",

    qetp_eventStartingDate_t: "qetp_eventStartingDate_t",
    qetp_orderBy_uid: "qetp_orderBy_uid",


    gs_creatorStartTime_t: "gs_creatorStartTime_t",
    gst_playerStartTime_t: "gst_playerStartTime_t",
    gst_players_byUserId_c: "gst_players_byUserId_c",

    // questBody
    qb_metadata_c: "qb_metadata_c",
    qb_langArr_ae: "qb_langArr_ae",
    qb_mainLang_e: "qb_mainLang_e",

    // questExplore
    qex_metadata_c: "qex_metadata_c",
    qex_langArr_ae: "qex_langArr_ae",
    qex_mainLang_e: "qex_mainLang_e",
    qex_creatorId_uid: "qex_creatorId_uid",
    qex_shortKeyPrefixId_s: "qex_shortKeyPrefixId_s",

    SUB_COLLECTION_QUEST_BACKUP: "SUB_COLLECTION_QUEST_BACKUP"
}

// http_endPointPath_of
export const http_endPointPath_of = {

    // DATABASE ONGOING
    DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F : (subCollectionName_e) => {
        switch(subCollectionName_e){

            // MAP
            case enum_subCollection_teamStatus.MAP_MISSIONS:
                return http_endPointPath_oa.DATABASE_ONGOING_TSS_MAP_MISSIONS

            case enum_subCollection_teamStatus.MAP_LAST_MISSIONS:
                return http_endPointPath_oa.DATABASE_ONGOING_TSS_MAP_LAST_MISSIONS

            // CARDS
            case enum_subCollection_teamStatus.CARDS_MISSIONS:
                return http_endPointPath_oa.DATABASE_ONGOING_TSS_CARDS_MISSIONS

            // MISSION LIST
            case enum_subCollection_teamStatus.LIST_MISSIONS:
                return http_endPointPath_oa.DATABASE_ONGOING_TSS_MISSIONS_RIDDLES

            case enum_subCollection_teamStatus.LIST_LAST_MISSIONS:
                return http_endPointPath_oa.DATABASE_ONGOING_TSS_MISSIONS_LAST_RIDDLES
        }
    },

    // FIRESTORE
    FIRESTORE_QUEST_BODY_F    : (questType_e) => {

        switch(questType_e){
            case enum_questTypes.CARDS:
                return http_endPointPath_oa.FIRESTORE_CARDS_BODY
            case enum_questTypes.OPEN_MAP:
                return http_endPointPath_oa.FIRESTORE_OPEN_MAP_BODY
            case enum_questTypes.MISSIONS:
                return http_endPointPath_oa.FIRESTORE_MISSIONS_BODY

        }

    },
    FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_F : (questType_e, questId_uid) => {

        switch(questType_e){
            case enum_questTypes.CARDS:
                return http_endPointPath_oa.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_CARDS.concat(questId_uid, "SUB_COLLECTION_QUEST_BACKUP")
            case enum_questTypes.OPEN_MAP:
                return http_endPointPath_oa.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_OPEN_MAP_BODY.concat(questId_uid, "SUB_COLLECTION_QUEST_BACKUP")
            case enum_questTypes.MISSIONS:
                return http_endPointPath_oa.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_MISSIONS_BODY.concat(questId_uid, "SUB_COLLECTION_QUEST_BACKUP")

        }

    },
}

// http_queryKeys_os
export const http_queryKeys_os = {
    orderBy : "orderBy",
    equalTo : "equalTo",
    startAt : "startAt",
    endAt : "endAt",
    limitToFirst : "limitToFirst",
    limitToLast : "limitToLast",
}


// ============== General ================

// http_initAutoTryToSendFailedRequest_fn
let runFirstLoad_b = false
export const http_initAutoTryToSendFailedRequest_fn = () => {

    const tryToResendRequests = () => {
        const networkActive_b = store_getStateValue_vo(store_var.networkActive).val
        const failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val

        if(networkActive_b || !runFirstLoad_b){
            const failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val
            store_setStateValue(store_var.failedHttpsCalls, {})
            obj_forEach_f(failedHttpsCalls_ao, requestData_o => eval(requestData_o.funName_s)({...requestData_o, firstTime_b:!runFirstLoad_b}))
            runFirstLoad_b = true;
        }

        date_setTimeout(tryToResendRequests, http_numbers_on.retrySendFailedRequestTime, "http_initAutoTryToSendFailedRequest_fn")
    }    
    // tryToResendRequests()
    date_setTimeout(tryToResendRequests, http_numbers_on.retrySendFailedRequestInitTime, "http_initAutoTryToSendFailedRequest_fn")
}


// ============== FB Auth ======================

// http_auth_logout
export const http_auth_logout = (cb_f) => {

    store_setStateValue(store_var.fb_auth, null)
    cb_f()

}

// http_auth_signIn_emailAndPass_fp
export const http_auth_signIn_emailAndPass_fp = (email_s, password_s, newUser_b) => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${newUser_b ? urls_o.signUp : urls_o.signInWithPassword}?key=${gv_FbConfig().apiKey}`,
        body_o          : {returnSecureToken: true, email: email_s, password: password_s},
        headers_o       : {"Content-Type" : "application/json"},
        })
        .then(ans_o => {

            const fbAuth_c = new FB_FbAuth({
                fa_userId_uid: ans_o.localId,
                fa_email_s: ans_o.email,
                fa_idToken_uid: ans_o.idToken,
                fa_refreshToken_uid: ans_o.refreshToken,
                fa_newUser_b: ans_o.isNewUser,
                fa_IdTokenExpiresInSec_n: parseInt(ans_o.expiresIn),
                fa_tokenDate_t: date_nowTime_t(),
                fa_lastLoginMethods_e : enum_loginMethods.email
            })
            store_setStateValue(store_var.fb_auth, fbAuth_c)

            return fbAuth_c
        })
        .catch(authEmailPassErrorAns_o => {

            throw authEmailPassErrorAns_o.error.errors[0].message
        })

}

// auth_signIn_anonymously_fp
export const http_auth_signIn_anonymously_fp = () => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.signUp}?key=${gv_FbConfig().apiKey}`,
        body_o          : {returnSecureToken: true},
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{

        const fbAuth_c = new FB_FbAuth({
            fa_userId_uid: fbAns_o.localId,
            fa_idToken_uid: fbAns_o.idToken,
            fa_refreshToken_uid: fbAns_o.refreshToken,
            fa_newUser_b: true,
            fa_IdTokenExpiresInSec_n: parseInt(fbAns_o.expiresIn),
            fa_tokenDate_t: date_nowTime_t(),
            fa_lastLoginMethods_e : enum_loginMethods.guest
        })
        store_setStateValue(store_var.fb_auth, fbAuth_c)

        return fbAuth_c
    })

}

// auth_signIn_google_fp
export const http_auth_signIn_google_fp = (googleIdToken_s, tokenId_uid) => {

    // let tokenId_uid= await auth_getIdToken_fp()

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.signInWithIdp}?key=${gv_FbConfig().apiKey}`,
        body_o          : {
            idToken             : tokenId_uid,
            requestUri          : 'http://localhost',
            postBody            : `id_token=${googleIdToken_s}&providerId=google.com`,
            returnSecureToken   : true,
            returnIdpCredential : false,
        },
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{

        let fbAuth_c = new FB_FbAuth({
            fa_userId_uid: fbAns_o.localId,
            fa_idToken_uid: fbAns_o.idToken,
            fa_refreshToken_uid: fbAns_o.refreshToken,
            fa_IdTokenExpiresInSec_n: parseInt(fbAns_o.expiresIn),
            fa_tokenDate_t: date_nowTime_t(),
            fa_newUser_b: fbAns_o.isNewUser,
            fa_name_s: fbAns_o.displayName,
            fa_email_s: fbAns_o.email,
            fa_photoUrl_s: fbAns_o.photoUrl,
            fa_lastLoginMethods_e : enum_loginMethods.google
        })
        store_setStateValue(store_var.fb_auth, fbAuth_c)

        return fbAuth_c
    })
}

// phone auth
export const http_auth_signIn_phone_fp = (phoneNumber, code, sessionInfo) => {

    // let tokenId_uid= await auth_getIdToken_fp()

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.signInWithPhoneNumber}?key=${gv_FbConfig().apiKey}`,
        body_o          : {
            sessionInfo         : sessionInfo,
            phoneNumber         : phoneNumber,
            code                : code,
            // temporaryProof      : true,
            // idToken : false,
        },
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{

        console.log(fbAns_o)
        // return fbAuth_c
    })
}
export const http_auth_signIn_phone_recaptchaParams_fp = () => {
    return httpRequest_fp({
        methods_e       : https_methods.GET,
        url_s           : `${urls_o.recaptchaParams}?key=${gv_FbConfig().apiKey}`,
        // body_o          : {},
        // headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{
        return  fbAns_o
    })
}
export const http_auth_signIn_phone_sendVerificationCode_fp = (phoneNumber, recaptchaStoken) => {

    // let tokenId_uid= await auth_getIdToken_fp()


        return httpRequest_fp({
            methods_e       : https_methods.POST,
            url_s           : `${urls_o.sendVerificationCode}?key=${gv_FbConfig().apiKey}`,
            body_o          : {
                "phoneNumber": phoneNumber,
                // "iosReceipt": "string",
                // "iosSecret": "string",
                // "recaptchaToken": fbAns_o.recaptchaStoken,
                // "recaptchaToken": fbAns_o.recaptchaSiteKey,
                "recaptchaToken": recaptchaStoken,
                // "tenantId": "string"
            },
            headers_o       : {"Content-Type" : "application/json"},
        }).then(fbAns_o =>{
            console.log(fbAns_o)

            // console.log()
            // return fbAuth_c
        })



}

// auth_signIn_facebook_fp
export const http_auth_signIn_facebook_fp = (facebookAccessToken_s, tokenId_uid) => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.signInWithIdp}?key=${gv_FbConfig().apiKey}`,
        body_o          : {
            idToken             : tokenId_uid,
            requestUri          : 'http://localhost',
            postBody            : `access_token=${facebookAccessToken_s}&providerId=facebook.com`,
            returnSecureToken   : true,
            returnIdpCredential: true,
        },
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{

        if(fbAns_o.verifiedProvider && fbAns_o.verifiedProvider.includes(enum_loginMethods.google)){
            return Promise.reject(enum_loginErrors.LOGIN_WITH_GOOGLE)
        }

        let fbAuth_c = new FB_FbAuth({
            fa_userId_uid: fbAns_o.localId,
            fa_idToken_uid: fbAns_o.idToken,
            fa_refreshToken_uid: fbAns_o.refreshToken,
            fa_IdTokenExpiresInSec_n: parseInt(fbAns_o.expiresIn),
            fa_tokenDate_t: date_nowTime_t(),
            fa_newUser_b: fbAns_o.isNewUser,
            fa_name_s: fbAns_o.displayName,
            fa_email_s: fbAns_o.email,
            fa_photoUrl_s: fbAns_o.photoUrl,
            fa_lastLoginMethods_e : enum_loginMethods.facebook
        })
        store_setStateValue(store_var.fb_auth, fbAuth_c)

        return fbAuth_c
    })

}

// auth_signIn_linkEmailPass_fp
export const http_auth_signIn_linkEmailPass_fp = (fbIdToken_s, email_s, password_s) => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.update}?key=${gv_FbConfig().apiKey}`,
        body_o          : {
            idToken: fbIdToken_s,
            email: email_s,
            password: password_s,
            returnSecureToken: true,
        },
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{


        let fbAuth_c = new FB_FbAuth({
            fa_userId_uid: fbAns_o.localId,
            fa_idToken_uid: fbAns_o.idToken,
            fa_refreshToken_uid: fbAns_o.refreshToken,
            fa_newUser_b: true,
            fa_IdTokenExpiresInSec_n: parseInt(fbAns_o.expiresIn),
            fa_tokenDate_t: date_nowTime_t(),
            fa_lastLoginMethods_e : enum_loginMethods.email
        })

        return fbAuth_c
    })

}

// http_auth_fetchProvidersForEmail_fp
export const http_auth_fetchProvidersForEmail_fp = (email_s) => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.createAuthUri}?key=${gv_FbConfig().apiKey}`,
        body_o          : {identifier: email_s, continueUri: 'http://localhost:8080'},
        headers_o       : {"Content-Type" : "application/json"},
    }).then(fbAns_o =>{
        return fbAns_o.allProviders ? fbAns_o.allProviders : []
    })

}

// http_auth_resetPassword_fp
export const http_auth_resetPassword_fp = (email_s) => {

    return httpRequest_fp({
        methods_e       : https_methods.POST,
        url_s           : `${urls_o.sendOobCode}?key=${gv_FbConfig().apiKey}`,
        body_o          : {requestType: "PASSWORD_RESET", email: email_s},
        headers_o       : {"Content-Type" : "application/json"},
    }).catch((fbAns_o) => {
        throw( fbAns_o.error.errors[0].message)
    })

}

// auth_getIdToken_fp
const auth_getIdToken_fp = (forceRefresh_b = false) => {

    return new Promise((resolve) => {
        const fbAuth_c = store_getStateValue_vo(store_var.fb_auth).val

        // 1) user not login
        if (fbAuth_c === null) {
            resolve(null)

        // 2) expired id token
        } else if (forceRefresh_b || fbAuth_c.fa_idTokenExpired_b()) {
            auth_getIdToken_refreshIdToken_fp(fbAuth_c.fa_idToken_uid, fbAuth_c.fa_refreshToken_uid, fbAuth_c.fa_lastLoginMethods_e).then(newFbAuth_c => {
                
                // try to get new fbAuth_c
                if(newFbAuth_c){
                    store_setStateValue(store_var.fb_auth, newFbAuth_c)
                // if failed return the prev  fbAuth_c
                }else{
                    newFbAuth_c = fbAuth_c
                }
                resolve(newFbAuth_c.fa_idToken_uid)
            })
        // 3) return IdToken
        } else {
            resolve(fbAuth_c.fa_idToken_uid)
        }
    })
}
const requestRefreshToken_byTokenId_p = {}
const auth_getIdToken_refreshIdToken_fp = (prevIdToken_s, refreshToken_s, lastLoginMethod_e) => {

    if (requestRefreshToken_byTokenId_p[prevIdToken_s] == null) {

        requestRefreshToken_byTokenId_p[prevIdToken_s] = new Promise(reslove => {
            httpRequest_fp({
                methods_e       : https_methods.POST,
                url_s           : `${urls_o.token}?key=${gv_FbConfig().apiKey}`,
                body_o          : {grant_type: 'refresh_token', refresh_token: refreshToken_s},
                headers_o       : {"Content-Type" : "application/json"},
                cb_f            : (fbAns_o) => {
                    const fbAuth_c = new FB_FbAuth({
                        fa_userId_uid: fbAns_o.user_id,
                        fa_idToken_uid: fbAns_o.id_token,
                        fa_refreshToken_uid: fbAns_o.refresh_token,
                        fa_IdTokenExpiresInSec_n: parseInt(fbAns_o.expires_in),
                        fa_tokenDate_t: date_nowTime_t(),
                        fa_lastLoginMethods_e : lastLoginMethod_e
                    })
        
                    reslove(fbAuth_c)
                },
                cb_error_f      : () => {
                    reslove(null)
                }
            })
        })
    }

    return requestRefreshToken_byTokenId_p[prevIdToken_s]
}

// ============== FB websocket ======================

// http_webSocket_init_f
export const http_webSocket_init_f = () => {
    http_database_webSocket_openAndAuth_f(gv_FbConfig().databaseURL)
    http_database_webSocket_openAndAuth_f(gv_FbConfig().databaseURL_ongoing)
}

// firebase_close
export const http_webSocket_close_f = () => {
    http_database_webSocket_close_f(gv_FbConfig().databaseURL)
    http_database_webSocket_close_f(gv_FbConfig().databaseURL_ongoing)
}

// http_database_webSocket_openAndAuth_f
export const http_database_webSocket_openAndAuth_f = (databaseUrl_s) => {

    const databaseSocket = new WebSocket(webSocket_getSocketUrl_fs(databaseUrl_s))

    const oldSocket_queriesSendData_byPathQueryStr_o = 
        socketData_byDatabaseUrl_o[databaseUrl_s]  ? socketData_byDatabaseUrl_o[databaseUrl_s].queriesSendData_byPathQueryStr_o : {}


    // set socket data
    socketData_byDatabaseUrl_o[databaseUrl_s] = {
        socket_o            : databaseSocket,

        // index1 index2
        socketIndex1_n      : socketData_byDatabaseUrl_o[databaseUrl_s] ? socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n : 1,
        socketIndex2_n      : socketData_byDatabaseUrl_o[databaseUrl_s] ? socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex2_n : 1,
        query_byIndex2_os   : socketData_byDatabaseUrl_o[databaseUrl_s] ? socketData_byDatabaseUrl_o[databaseUrl_s].query_byIndex2_os : {},
        path_byIndex1_as    : socketData_byDatabaseUrl_o[databaseUrl_s] ? socketData_byDatabaseUrl_o[databaseUrl_s].path_byIndex1_as : {},

        // split messages
        splitMsgNum         : 0,
        currentData_s       : "",

        // cb_byIndex1_n       : {},
        cb_serverRecivedData_byIndex1_f : {},

        // reopen connection
        queriesSendData_byPathQueryStr_o : oldSocket_queriesSendData_byPathQueryStr_o,

        // auth
        requestBeforeAuth_af    : [],
        authExpiration_t        : null,
        firstAuth_b             : false,
    }

    // 1) open
    databaseSocket.onopen = (e) => {
        console.log("onopen!", databaseUrl_s)

        // 2) send firebase sdkVersion
        databaseSocket.send(JSON.stringify({
            t : socketsMessageTypes_es.data,
            d : {
                r : socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n++,
                a : socketAction.firebaseVersion,
                b : { c : {"sdk.js.7-2-0":1}}}
        }));

        // 3) onStoreAuthChange
        store_listener_set_f(store_var.fb_auth, databaseUrl_s, (fbAuth_c) => {

            socketData_byDatabaseUrl_o[databaseUrl_s].firstAuth_b = false

            // reAuth websocket
            webSocket_auth_f(databaseUrl_s, false, ()=>{

                // do after first auth
                if(!socketData_byDatabaseUrl_o[databaseUrl_s].firstAuth_b){

                    // update first auth
                    socketData_byDatabaseUrl_o[databaseUrl_s].firstAuth_b = true

                    // set onDisconnect
                    if(fbAuth_c && databaseUrl_s === gv_FbConfig().databaseURL){
                        webSocket_setOnlineListener_f(databaseSocket, databaseUrl_s, fbAuth_c)
                    }

                    // call oldSocket queries
                    obj_forEach_f(oldSocket_queriesSendData_byPathQueryStr_o, (sendData_o) => {
                        socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(sendData_o)
                    })

                    // call all stackCallBacks
                    socketData_byDatabaseUrl_o[databaseUrl_s].requestBeforeAuth_af.forEach(func_f => {func_f()})
                    socketData_byDatabaseUrl_o[databaseUrl_s].requestBeforeAuth_af = []

                    // call cache failed websocket request
                    const store_failedWebSocketUpdates_byRequestDate_o = store_getStateValue_vo(store_var.failedWebSocketUpdates).val
                    obj_forEach_f(store_failedWebSocketUpdates_byRequestDate_o, requestData_o => http_websocket_multiUpdate_f({...requestData_o}))
                    store_setStateValue(store_var.failedWebSocketUpdates, {})
                  
                }
            })
        })

    };

    // close
    databaseSocket.onclose = () => {
        console.log("onClose webSocket!!!!", databaseUrl_s)
        setTimeout(() => {
            http_database_webSocket_openAndAuth_f(databaseUrl_s)
        }, http_numbers_on.retryToOpenWebSocketTime)
    }

    // message
    databaseSocket.onmessage = (event) => {

        // 1) set data_o
        let data_o;

        // 1.1) set nextNumOfMessages_n
        if (event.data.length <= 2 && validator_number_fb(Number(event.data))) {
            socketData_byDatabaseUrl_o[databaseUrl_s].splitMsgNum = Number(event.data)
            return

        // 1.2) sum split msg
        }else if(socketData_byDatabaseUrl_o[databaseUrl_s].splitMsgNum > 1){
            socketData_byDatabaseUrl_o[databaseUrl_s].splitMsgNum--
            socketData_byDatabaseUrl_o[databaseUrl_s].currentData_s += event.data
            return

        // 1.3) last split message
        }if(socketData_byDatabaseUrl_o[databaseUrl_s].splitMsgNum === 1){
            socketData_byDatabaseUrl_o[databaseUrl_s].splitMsgNum = 0
            socketData_byDatabaseUrl_o[databaseUrl_s].currentData_s += event.data
            data_o = JSON.parse(socketData_byDatabaseUrl_o[databaseUrl_s].currentData_s)
            socketData_byDatabaseUrl_o[databaseUrl_s].currentData_s = ""

        // 1.4) regular message
        }else{
            data_o = JSON.parse(event.data)
        }

        // 2) handle data_o
        switch(data_o.t){
            case socketsMessageTypes_es.info:
                const newSocketId_s = data_o.d.d.h
                const dontKnow2 = data_o.d.d.s
                const serverTime_t = data_o.d.d.ts
                const innerType = data_o.d.t  
                const offset = serverTime_t - new Date().getTime()
                
                switch(innerType){
                    case "e" : 
                    getErrorFromServer_byDbUrl_b[databaseUrl_s] = true
                        break;
                    case "h": 
                        store_setStateValue(store_var.system_serverTimeOffset_n, offset)

                        const newSocketDatabaseId_be_s = store_getStateValue_vo(store_var.system_newSocketDatabaseId_be_s).val
                        newSocketDatabaseId_be_s[databaseUrl_s] = newSocketId_s
        
                        store_setStateValue(store_var.system_newSocketDatabaseId_be_s, newSocketDatabaseId_be_s)
                        break;
                }


                break;
            case socketsMessageTypes_es.data:

                let messageAction_e = data_o.d.a;
                let index1_n        = data_o.d.r;

                let path_s          = data_o.d.b.p;
                let index2_n        = data_o.d.b.t;
                let info_s          = data_o.d.b.s;
                let data            = validator_obj_fb(data_o.d.b.d) && validator_objEmpty_fb(data_o.d.b.d) ? null : data_o.d.b.d;
                let auth_o          = data_o.d.b.d ? data_o.d.b.d.auth : null
                let expiresInMinutes_n       = data_o.d.b.d ? data_o.d.b.d.expires : null

                // index2_n != null => query request
                let query_os = index2_n != null ? socketData_byDatabaseUrl_o[databaseUrl_s].query_byIndex2_os[index2_n] : {}

                // sdk version call
                if(index1_n === 1){ return }

                // auth call
                if(auth_o != null){
                    socketData_byDatabaseUrl_o[databaseUrl_s].authExpiration_t = (expiresInMinutes_n * 1000) - (5 * 60 * 1000)  // remove 5 minutes just in case
                    return
                }

                // start connection
                if(info_s === "ok"){

                    // only for request to start listen
                    if(socketData_byDatabaseUrl_o[databaseUrl_s].path_byIndex1_as[index1_n]){
                        serverLocalStorage_listener_establishConnection_f({
                            path_as     : [databaseUrl_s].concat(socketData_byDatabaseUrl_o[databaseUrl_s].path_byIndex1_as[index1_n]),
                            query_os    : query_os
                        })
                    }

                    // if(index1_n && socketData_byDatabaseUrl_o[databaseUrl_s].cb_byIndex1_n[index1_n]){
                    //     socketData_byDatabaseUrl_o[databaseUrl_s].cb_byIndex1_n[index1_n]()
                    // }

                    if(index1_n && socketData_byDatabaseUrl_o[databaseUrl_s].cb_serverRecivedData_byIndex1_f[index1_n]){
                        socketData_byDatabaseUrl_o[databaseUrl_s].cb_serverRecivedData_byIndex1_f[index1_n]()
                    }

                    return
                }

                // permission denied
                if(data === "Permission denied"){
                    console.trace()
                    console.log("Permission denied", data_o)
                    return
                }

                // permission denied
                if(data === "Auth token is expired."){
                    console.trace()
                    console.log("Auth token is expired.", data_o)
                    webSocket_auth_f(databaseUrl_s, false, ()=>{})
                    return
                }

                // path_s != null => null data
                let path_as = path_s != null ? path_s.split("/") : socketData_byDatabaseUrl_o[databaseUrl_s].path_byIndex1_as[index1_n]

                // merge action
                if(messageAction_e === socketAction.merge){

                    // old update
                    // // 1. setObj
                    // let dataObj_o = {}
                    // for(let key_s in data){
                    //     let fullPaths_as = key_s.split("/")
                    //     let dataPointer_o = dataObj_o
                    //     fullPaths_as.forEach((path_s, index_n) => {
                    //         if(index_n < fullPaths_as.length - 1 ){
                    //             if(dataPointer_o[path_s] == null) {
                    //                 dataPointer_o[path_s] = {}
                    //             }
                    //             dataPointer_o = dataPointer_o[path_s]
                    //         }else{
                    //             dataPointer_o[path_s] = data[key_s]
                    //         }
                    //     })
                    // }
                    //
                    // // 2. updatePath
                    // let pathPrefix_as = []
                    // console.log(dataObj_o)
                    //
                    // while(Object.keys(dataObj_o).length === 1){
                    //     let path_s = Object.keys(dataObj_o)[0]
                    //     pathPrefix_as.push(path_s)
                    //     dataObj_o = dataObj_o[path_s]
                    // }
                    //
                    // // 3. updateData
                    // serverLocalStorage_dataChange_f({
                    //     path_as     : [databaseUrl_s].concat(path_as, pathPrefix_as),
                    //     query_os    : query_os,
                    //     data        : dataObj_o
                    // })


                    let localStorageMultiData_ac = []

                    const key_as = Object.keys(data)
                    key_as.forEach(key_s => {
                        const lastPath_as = key_s.split("/")

                        localStorageMultiData_ac.push(new FB_LocalStorageUpdateMulti({
                            lsum_data_o   : data[key_s],
                            lsum_path_as  : [databaseUrl_s].concat(path_as, lastPath_as),
                            lsum_query_os : query_os ? query_os : {},
                        }))

                    })

                    serverLocalStorage_dataChange_multiData_f(localStorageMultiData_ac)

                // regular
                }else{
                    serverLocalStorage_dataChange_f({
                        path_as     : [databaseUrl_s].concat(path_as),
                        query_os    : query_os,
                        data        : data
                    })
                }


                //

                // if(path_s != null){
                //
                //     // console.log([databaseUrl_s].concat(path_s.split("/")))
                //     serverStorage3_listener_update_f({
                //         path_as     : path_s.split("/"),
                //         index2_n    : index2_n,
                //         data_o      : data
                //     })
                // }else{
                //     if(databaseUrl_s === http_database_es.database_ongoing){
                //         if(index1_n > 2){
                //             // serverStorage3_listener_update_f({
                //             //     path_as     : path_s.split("/"),
                //             //     index2_n    : index2_n,
                //             //     data_o      : null
                //             // })
                //         }
                //     }
                // }

                break;
            default:
                console.log("other type", data_o)
        }
    }

    // on error
    databaseSocket.onerror = (e) => {
        socketData_byDatabaseUrl_o[databaseUrl_s].firstAuth_b = true

        socketData_byDatabaseUrl_o[databaseUrl_s].requestBeforeAuth_af.forEach(func_f => {func_f()})
        socketData_byDatabaseUrl_o[databaseUrl_s].requestBeforeAuth_af = []
        // throw e
    }

    // keep alive
    webSocket_keepLive_set_f(databaseUrl_s)

}

// http_database_webSocket_close_f
export const http_database_webSocket_close_f = (databaseUrl_s) => {

    // 1) remove store listener
    store_listener_remove_f(store_var.fb_auth, databaseUrl_s)

    // 2) remove keep alive
    webSocket_keepLive_close_f(databaseUrl_s)

    // 3 close socket
    let databaseSocket = socketData_byDatabaseUrl_o[databaseUrl_s].socket_o
    databaseSocket.close()
}

// http_websocket_multiUpdate_f
export const http_websocket_multiUpdate_f = ({basePath_as, dataToSend_ao, retryFailedMsg_b=true, requestDate_t= (new Date()).getTime(), cb_f = () => {}}) => {

    date_doOnlyOnce_fn('http_websocket_multiUpdate_f' + basePath_as.toString(),() => {

        const databaseUrl_s = basePath_as[0]
        const copy_dataToSend_ao = obj_deepCopy_f(dataToSend_ao)
        const index1_n = socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n++

        // 1) add call to failed msg 
        if(retryFailedMsg_b){
            const store_failedWebSocketUpdates_byRequestDate_o = store_getStateValue_vo(store_var.failedWebSocketUpdates).val
            store_setStateValue(store_var.failedWebSocketUpdates, {...store_failedWebSocketUpdates_byRequestDate_o, [requestDate_t] : {basePath_as, dataToSend_ao:copy_dataToSend_ao, retryFailedMsg_b, requestDate_t}})
        }

        // // 2) set callback
        socketData_byDatabaseUrl_o[databaseUrl_s].cb_serverRecivedData_byIndex1_f[index1_n] = () => {

            // 2.1) add clean cache failed socket calls
            if(retryFailedMsg_b){
                const store_failedWebSocketUpdates_byRequestDate_o = store_getStateValue_vo(store_var.failedWebSocketUpdates).val
                delete store_failedWebSocketUpdates_byRequestDate_o[requestDate_t]
                store_setStateValue(store_var.failedWebSocketUpdates, store_failedWebSocketUpdates_byRequestDate_o)
            }

            // 2.2) callBack
            cb_f()
        }
        
        // 3) socket send data
        websocket_multiUpdate_f({
            index1_n,
            databaseUrl_s,
            basePath_as     : basePath_as.slice(1),
            dataToSend_ao   : dataToSend_ao,
        })

        // 4) update localStorage
        const localStorageMultiData_ac =[]
        dataToSend_ao.forEach(dataToSend_o => {

            // showLoader for specific message
            if(dataToSend_o.data_o && dataToSend_o.data_o.wsr_serverReceivedData_b){
                dataToSend_o.data_o.wsr_serverReceivedData_b = false
            }

            localStorageMultiData_ac.push(new FB_LocalStorageUpdateMulti({
                lsum_data_o   : dataToSend_o.data_o,
                lsum_path_as  : dataToSend_o.path_as,
                lsum_query_os : {},
            })) 
        })

        serverLocalStorage_dataChange_multiData_f(localStorageMultiData_ac)
        
    })
}

// webSocket_auth_f
const webSocket_auth_f = (databaseUrl_s, forceRefresh_b, cb_f = () =>{}) => {


    auth_getIdToken_fp(forceRefresh_b).then((ideToken_s) => {

        if(socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState !== WebSocket.OPEN){
            return
        }

        // if(ideToken_s == null){
        //     return
        // }

        // send user auth
        socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(JSON.stringify({
            t : socketsMessageTypes_es.data,
            d : {
                r : socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n++,
                a : socketAction.auth,
                b : { "cred" : ideToken_s}
            }}));

        cb_f()
    })
}

// webSocket_listener_open_wrapper_fn
const webSocket_listener_open_wrapper_fn = ({databaseUrl_s, path_as, query_os={}, cbError_f}) => {

    const index2 = socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex2_n++

    if(!socketData_byDatabaseUrl_o[databaseUrl_s].firstAuth_b){
        socketData_byDatabaseUrl_o[databaseUrl_s].requestBeforeAuth_af.push(() => {
            webSocket_listener_open_fn({databaseUrl_s, path_as, query_os, index2, cbError_f})
        })
    }else{
        webSocket_listener_open_fn({databaseUrl_s, path_as, query_os, index2, cbError_f})
    }

    return index2
}

// webSocket_listener_open_fn
const webSocket_listener_open_fn = ({databaseUrl_s, path_as, query_os={}, index2, cbError_f = () => {}}) => {
       
    const index1 = socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n++
    const path_s = createPath_fs(path_as)
    const query_s = webSocket_getSocketQuery_os(query_os)

    let sendData_o = JSON.stringify({
        t : socketsMessageTypes_es.data,
        d : {
            r : index1,
            a : socketAction.query,
            b : {
                p : path_s,
                q : query_s,
                t : index2,
                h : ""
            }
        }
    })

    socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(sendData_o);

    socketData_byDatabaseUrl_o[databaseUrl_s].queriesSendData_byPathQueryStr_o[path_s+query_s]  = sendData_o
    socketData_byDatabaseUrl_o[databaseUrl_s].query_byIndex2_os[index2]                         = query_os
    socketData_byDatabaseUrl_o[databaseUrl_s].path_byIndex1_as[index1]                          = path_as

    //  if socket is close return from the localStorage
    if([WebSocket.CLOSED, WebSocket.CLOSING].includes(socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState)){
        cbError_f()
    }
  
}

// websocket_multiUpdate_f
const websocket_multiUpdate_f = ({index1_n, databaseUrl_s, dataToSend_ao, basePath_as}) => {

    //  if socket is close return from the localStorage
    // if([WebSocket.CLOSED, WebSocket.CLOSING].includes(socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState)){
    //     return
    // }


    const basePath_s = createPath_fs(basePath_as)
    let data_byPath_o = {}

    dataToSend_ao.forEach(dataToSend_o => {
        data_byPath_o[createPath_fs(dataToSend_o.path_as.slice(1))] = getClassAsObj_f(dataToSend_o.data_o)
    })

    const sendData_o = JSON.stringify({
        t : socketsMessageTypes_es.data,
        d : {
            r : index1_n,
            a : socketAction.merge,
            b : {
                p : basePath_s,
                d : data_byPath_o // not sure if value can be obj
            }
        }
    })

    socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(sendData_o)
}

// webSocket_listener_stop_f
const webSocket_listener_stop_f = ({database_s, path_as, query_os={}, index2_n}) => {

    let path_s = createPath_fs(path_as)
    let query_s = webSocket_getSocketQuery_os(query_os)
    delete socketData_byDatabaseUrl_o[database_s].queriesSendData_byPathQueryStr_o[path_s+query_s]


    if(socketData_byDatabaseUrl_o[database_s].socket_o.readyState !== WebSocket.OPEN){
        return 
    }

    socketData_byDatabaseUrl_o[database_s].socket_o.send(JSON.stringify({
        t : socketsMessageTypes_es.data,
        d : {
            r : socketData_byDatabaseUrl_o[database_s].socketIndex1_n++,
            a : socketAction.stopListening,
            b : {
                p : path_s,
                q : query_s,
                t : index2_n,  // equal to the send id
            }
        }
    }));

}

// webSocket_keepLive_set_f
let getErrorFromServer_byDbUrl_b = {} 
const webSocket_keepLive_set_f = (databaseUrl_s) => {

    getErrorFromServer_byDbUrl_b[databaseUrl_s] = true

    date_setInterval( "webSocket_keepLive_set_f" + databaseUrl_s, http_numbers_on.keepAliveTimeout, null, () => {


        // console.log(databaseUrl_s , 'socket connection = ', temp[socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState])
        if(socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState === WebSocket.OPEN){
            // auth expired
            if( socketData_byDatabaseUrl_o[databaseUrl_s].authExpiration_t
                && date_newDate_fd().getTime() > socketData_byDatabaseUrl_o[databaseUrl_s].authExpiration_t){
                // console.log("keepWebSocketLive_f - webSocket_auth_f", socketData_byDatabaseUrl_o[databaseUrl_s].authExpiration_t)
                webSocket_auth_f(databaseUrl_s, true,  () =>{})
            }else{
                // keep alive
                if(getErrorFromServer_byDbUrl_b[databaseUrl_s]){
                    getErrorFromServer_byDbUrl_b[databaseUrl_s] = false

                    // only two meesages trigger the error from the server
                    socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(1);
                    socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.send(1);
                }else{
                    http_database_webSocket_openAndAuth_f(databaseUrl_s)
                }
                
            }


        }else if([WebSocket.CLOSED, WebSocket.CLOSING].includes(socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState)){
            // console.log("keepWebSocketLive_f - readyState", socketData_byDatabaseUrl_o[databaseUrl_s].socket_o.readyState)
            http_database_webSocket_openAndAuth_f(databaseUrl_s)
        }

    }, null)
}

// webSocket_keepLive_close_f
const webSocket_keepLive_close_f = (databaseUrl_s) => {

    date_removeInterval("keepWebSocketLive_f" + databaseUrl_s)

}

// webSocket_getSocketUrl_fs
const webSocket_getSocketUrl_fs = (databaseUrl) => {

    const newSocketDatabaseId_be_s = store_getStateValue_vo(store_var.system_newSocketDatabaseId_be_s).val

    if(newSocketDatabaseId_be_s[databaseUrl] == null){
        return "wss" + databaseUrl.substring(5) + "/.ws?v=5"
    }

    switch(databaseUrl){
        case gv_FbConfig().databaseURL:
            return "wss://" + newSocketDatabaseId_be_s[databaseUrl] + "/.ws?v=5&ns=" + gv_FbConfig().projectId

        case gv_FbConfig().databaseURL_ongoing:
            return "wss://" + newSocketDatabaseId_be_s[databaseUrl] + "/.ws?v=5&ns=" + gv_FbConfig().projectId_ongoing
    }

}

// webSocket_getSocketQuery_os
const webSocket_getSocketQuery_os = (query_os) => {
    let ans_o = {}

    obj_forEach_f(query_os, (val, queryName) => {

        if(val == null){return}

        switch(queryName){

            case http_queryKeys_os.orderBy:
                if(query_os.startAt || query_os.endAt || http_queryKeys_os.equalTo){
                    ans_o.i = val;
                }
                break;

            case http_queryKeys_os.equalTo:
                ans_o.sp = val;
                ans_o.ep = val;
                break;

            case http_queryKeys_os.startAt:
                ans_o.sp = val;
                break;

            case http_queryKeys_os.endAt:
                ans_o.ep = val;
                break;

            case http_queryKeys_os.limitToFirst:
                ans_o.l = val;
                ans_o.vf = "l";
                break;

            case http_queryKeys_os.limitToLast:
                ans_o.l = val;
                ans_o.vf = "r";
                break;
        }

    })

    return ans_o

}

// webSocket_setOnlineListener_f
const webSocket_setOnlineListener_f = (databaseSocket_o, databaseUrl_s, fbAuth_c) => {

    let path_os = http_endPointPath_oa.PUDSC_ONLINE_USERS.concat(fbAuth_c.fa_userId_uid)

    // set online user
    let ud_onlineUser_c = new FB_UserDataSub_OnlineUser({
        ud_os_userId_uid : fbAuth_c.fa_userId_uid,
        ud_os_online_b :  true
    })
    http_database_updateData_f({
        path_as : path_os,
        data_c : ud_onlineUser_c,
        cb_f : () => {}
    })

    // set offline user
    let ud_offlineUser_c = new FB_UserDataSub_OnlineUser({
        ud_os_userId_uid : fbAuth_c.fa_userId_uid,
        ud_os_online_b :  false
    })
    databaseSocket_o.send(JSON.stringify({
        "t" : socketsMessageTypes_es.data,
        "d" : {
            "r": socketData_byDatabaseUrl_o[databaseUrl_s].socketIndex1_n++,
            "a": socketAction.onDisconnect,
            "b": {
                "p": "/" + createPath_fs(path_os.splice(1)),
                "d": getClassAsObj_f(ud_offlineUser_c)
            }
        }
    }));
}


// ============== FB functions ======================

// http_functions_sendRequest_f
export const http_functions_fp = ({path_as, data_c}) => {

    return httpCall_withAuthorizationHeader_fp({
        methods_e       : https_methods.POST,
        url_s           : createPath_fs(path_as),
        body_o          : getClassAsObj_f(data_c),
    })

}




// ============== FB firestore ======================

// http_firestore_doc_get
export const http_firestore_doc_get = ({path_as, getOnlyFromServer_b=false, cacheFallback_b, cb_f, cb_error_f}) => {

    serverLocalStorage_getDataOnce_f({
        path_as,
        getOnlyFromServer_b,
        cacheFallback_b, 
        getServerData_f : (storageCb_f, storageErrorCb_f) => {

            httpCall_withAuthorizationHeader_fp({
                methods_e   : https_methods.GET,
                url_s       : createPath_fs(path_as),
                cb_f        : (fbDoc) => {

                    storageCb_f(firestoreDocToObj(fbDoc.fields))
                },
                cb_error_f : storageErrorCb_f
            })
        },

        cb_f
    })

}

// http_firestore_doc_getAll
export const http_firestore_doc_getAll = ({path_as, cb_f}) => {


    let parseData_ao =[]

    let maxCalls_n = 40

    serverLocalStorage_getDataOnce_f({
        path_as : path_as,

        getServerData_f : (storageCb_f) => {

            let callServer_f = (documents_ao, query_o) => {

                httpCall_withAuthorizationHeader_fp({
                    methods_e   : https_methods.GET,
                    url_s       : createPath_fs(path_as) + createQuery_fs(query_o),
                    cb_f        : (data_o) => {
                        documents_ao.push(...data_o.documents)

                        let nextPageToken_s = data_o.nextPageToken
                        let fbDoc_ao = Object.values(documents_ao)
                        let data_oc = []

                        fbDoc_ao.forEach( (data_o) =>{data_oc.push(firestoreDocToObj(data_o.fields))})

                        if(nextPageToken_s && --maxCalls_n > 0 ){
                            callServer_f(documents_ao, { pageToken : nextPageToken_s})
                        }else{
                            storageCb_f(data_oc)
                        }
                    }
                })
            }

            callServer_f([], {})

        },

        cb_f : (data_o) => {

            parseData_ao.push(... Object.values(data_o))

            cb_f(parseData_ao)


        }
    })

}

// http_firestore_doc_getAll_withFilter
export const http_firestore_doc_filter_getAll_f = ({path_as, locationType_e, guidedQuest_b, creatorId_uid, cb_f}) => {

    let collection = path_as[path_as.length-1]
    let shortPath_as = path_as.slice(0, path_as.length-1)

    let filterActiveQuest_o = {
        "fieldFilter" : {
            "field": {"fieldPath": `${FB_QuestExplore.qex_l_metadata_c}.${FB_QuestExplore_Metadata.qexm_l_active_b}`},
            "op":"EQUAL",
            "value": {[http_firestore_types.booleanValue]: true}
        },
    }
    let filter_locationType_o = {
        "fieldFilter" : {
            "field": {"fieldPath": `${FB_QuestExplore.qex_l_metadata_c}.${FB_QuestExplore_Metadata.qexm_l_questLocationType_e}`},
            "op":"EQUAL",
            "value": {[http_firestore_types.stringValue]: locationType_e}
        }
    }
    let filter_creatorId_o = {
        "fieldFilter" : {
            "field": {"fieldPath": `${FB_QuestExplore.qex_l_creatorId_uid}`},
            "op":"EQUAL",
            "value": {[http_firestore_types.stringValue] : creatorId_uid}
        }
    }
    let filter_guided_o = {
        "fieldFilter" : {
            "field": {"fieldPath": `${FB_QuestExplore.qex_l_metadata_c}.${FB_QuestExplore_Metadata.qexm_l_guide_b}`},
            "op":"EQUAL",
            "value": {[http_firestore_types.booleanValue] : guidedQuest_b}
        }
    }

    let whereFilter_o = null
    if(locationType_e){
        whereFilter_o = {
            compositeFilter:{
                "op": "AND",
                "filters": [filterActiveQuest_o, filter_locationType_o]
            }
        }
    }else if(guidedQuest_b != null) {
        whereFilter_o = {
            compositeFilter:{
                "op": "AND",
                "filters": [filterActiveQuest_o, filter_guided_o]
            }
        }

    }else if(creatorId_uid) {
        whereFilter_o = {
            compositeFilter:{
                "op": "AND",
                "filters": [filterActiveQuest_o, filter_creatorId_o,]
            },
        }
    }else{
        whereFilter_o = filterActiveQuest_o
    }


    httpCall_withAuthorizationHeader_fp({
        methods_e : https_methods.POST,
        url_s : `${createPath_fs(shortPath_as)}:runQuery`,
        body_o: {
            "structuredQuery": {
                "where" : whereFilter_o,
                "from": [{"collectionId": collection}]
            }
        },
        cb_f : (data_ao) => {
            if(data_ao[0].document == null){
                data_ao = []
            }
            let parseData_ao = data_ao.map( (data_o) =>{return firestoreDocToObj(data_o.document.fields)})
            cb_f(parseData_ao)
        }
    })
}

// http_firestore_doc_getAll_withFilter
export const http_firestore_doc_getAll_withLocFilter_f = ({path_as, cb_f}) => {

    let collection = path_as[path_as.length-1]
    let shortPath_as = path_as.slice(0, path_as.length-1)

    httpCall_withAuthorizationHeader_fp({
        methods_e : https_methods.POST,
        url_s : `${createPath_fs(shortPath_as)}:runQuery`,
        body_o: {
            "structuredQuery": {
                "where" : {
                    compositeFilter:{
                        "op": "AND",
                        "filters": [
                            {
                                "fieldFilter" : {
                                    "field": {"fieldPath": `${http_classSubChildName_os.qex_metadata_c}.${http_classSubChildName_os.qexm_active_b}`},
                                    "op":"EQUAL",
                                    "value": {[http_firestore_types.booleanValue]: "true"}
                                },
                            },
                            {
                                "fieldFilter" : {
                                    "field": {"fieldPath": `qex_metadata_c.qexm_questLocationType_e`},
                                    "op":"EQUAL",
                                    "value": {[http_firestore_types.stringValue]: enum_questLocationsTypes_s.outside}
                                }
                            }
                        ]
                    }
                },
                "from": [{"collectionId": collection}]
            }

        },
        cb_f : (data_ao) => {
            if(!data_ao[0].document){
                data_ao = []
            }

            let parseData_ao = data_ao.map( (data_o) =>{return firestoreDocToObj(data_o.document.fields)})
            cb_f(parseData_ao)
        }
    })
}

// http_firestore_doc_update
export const http_firestore_doc_update_f = ({path_as, newData_c, cb_f}) => {

    let firestoreDoc = objToFirestoreDoc(newData_c)
    let updateMask_s = getUpdateMask_s(firestoreDoc)


    httpCall_withAuthorizationHeader_fp({
        methods_e : https_methods.PATCH,
        url_s : `${createPath_fs(path_as)}?${updateMask_s}`,
        body_o : {
            fields: firestoreDoc

        },
        cb_f : (data) => {

            cb_f(firestoreDocToObj(data.fields))
        }
    })

    serverLocalStorage_dataChange_f({
        path_as   : path_as,
        data      : newData_c
    })

}

// http_firestore_doc_getNewId
export const http_firestore_doc_getNewId_f = ({path_as, cb_f}) => {

    httpCall_withAuthorizationHeader_fp({
        methods_e   : https_methods.POST,
        url_s       : createPath_fs(path_as),
        body_o : {
            fields:  {newId : {[http_firestore_types.booleanValue] : true}}
        },
        cb_f : (data) => {
            let splitName = data.name.split("/")
            let newId = splitName[splitName.length-1]
            cb_f(newId)
        }
    })

}

// objToFirestoreDoc
const objToFirestoreDoc = (obj) => {

    let ans = {}

    obj_forEach_f(obj, (data,key) => {
        // console.log(key)
        if(validator_null_fb(data) || validator_function_fb(data)) {
            // do nothing

        }else if(validator_array_fb(data)){

            // ans[key] = {
            //     [http_firestore_types.mapValue] : {
            //         fields : objToFirestoreDoc(data)
            //     }
            // }

            data.forEach(data2_o => {
                if(validator_array_fb(data2_o)){
                    console.log(data,key)
                }
            })

            ans[key] = {
                [http_firestore_types.arrayValue] : {
                    values : Object.values(objToFirestoreDoc(data))
                }
            }

        }else if(validator_obj_fb(data)){
            ans[key] = {
                [http_firestore_types.mapValue] : {
                    fields : objToFirestoreDoc(data)
                }
            }
        }else if(validator_number_double_fb(data)){
            ans[key] = {[http_firestore_types.doubleValue] : data}

        }else if(validator_number_fb(data)){
            ans[key] = {[http_firestore_types.integerValue] : "" + data}

        }else if(validator_string_fb(data)){
            ans[key] = {[http_firestore_types.stringValue] : data}

        }else if(validator_boolean_fb(data)){
            ans[key] = {[http_firestore_types.booleanValue] : data}
        }else{
            console.log("objToFirestoreDoc value=", data)
            console.log("objToFirestoreDoc typeof=", typeof data)
        }

    })

    return ans
}

// firestoreDocToObj
const firestoreDocToObj = (obj) => {

    let ans = {}
    obj_forEach_f(obj, (data,key) => {
        let value = Object.values(data)[0]
        let firebaseType = Object.keys(data)[0]

        switch (firebaseType){

            case http_firestore_types.arrayValue:
                ans[key] = Object.values(firestoreDocToObj(value.values))
                break;

            case http_firestore_types.mapValue:
                ans[key] = firestoreDocToObj(value.fields)
                break;

            case http_firestore_types.integerValue:
                ans[key] = parseInt(value)
                break;

            case http_firestore_types.stringValue:
            case http_firestore_types.booleanValue:
            case http_firestore_types.doubleValue:
                ans[key] = value
                break;


            case http_firestore_types.nullValue:
                break;

            default:
                ans[key] = value
                console.log("firestoreDocToObj default=", firebaseType, key, value)

        }

    })

    return ans
}



// ============== FB Database =====================

// http_database_onValueListener_open
export const http_database_onValueListener_open_f = ({viewName_s, path_as, query_os={}, cacheFallback_b = false, cb_f}) => {

    removeUnnecessaryQueries_fo(query_os)
    const databaseUrl_s = path_as[0]

    serverLocalStorage_listener_add_f({
        path_as,
        query_os,
        webView_s   : viewName_s,
        cacheFallback_b,
        childListener_b : false,
        serverFuc_fn : ({cbError_f}) => {
            
            return webSocket_listener_open_wrapper_fn({
                databaseUrl_s,
                path_as : path_as.slice(1),
                query_os,
                cbError_f,
            })
        },
        cb_f : cb_f
    })

}

// http_database_onValueListener_close
export const http_database_onValueListener_close_f = ({viewName_s, path_as}) => {

    // todo serverStorage add onValue listener

    let database_s = path_as[0]
    let cleanPath_as = path_as.slice(1)

    serverLocalStorage_listener_remove_f({
        path_as         : path_as,
        webView_c       : viewName_s,
        serverRemove_f  : (index2_n) => {

            webSocket_listener_stop_f({
                database_s  : database_s,
                path_as     : cleanPath_as,
                index2_n    : index2_n,
            })

        }
    })

    // eventSource_close_f({path_as: path_as.concat(urlSuffix_os.database_json)})
}

// http_database_onChildListener_open
export const http_database_onChildListener_open_f = ({viewName_s, path_as, cacheFallback_b =false, query_os={}, cb_f}) => {

    removeUnnecessaryQueries_fo(query_os)
    const databaseUrl_s = path_as[0]

    serverLocalStorage_listener_add_f({
        path_as,
        query_os,
        webView_s : viewName_s,
        childListener_b : true,
        cacheFallback_b,
        serverFuc_fn : ({cbError_f}) => {
            return webSocket_listener_open_wrapper_fn({databaseUrl_s, path_as: path_as.slice(1), query_os, cbError_f})
        },
        cb_f
    })

}

// http_database_onChildListener_close
export const http_database_onChildListener_close_f = ({viewName_s, query_os={}, path_as}) => {

    removeUnnecessaryQueries_fo(query_os)

    let database_s = path_as[0]
    let cleanPath_as = path_as.slice(1)

    serverLocalStorage_listener_remove_f({
        path_as         : path_as,
        query_os        : query_os,
        webView_c       : viewName_s,
        serverRemove_f  : (index2_n) => {

            webSocket_listener_stop_f({
                database_s : database_s,
                path_as : cleanPath_as,
                query_os: query_os,
                index2_n: index2_n,
            })

        }
    })

}



// http_database_getOnce_f
export const http_database_getOnce_f = ({path_as, query_os={}, cacheFallback_b, cb_f}) => {

    serverLocalStorage_getDataOnce_f({
        path_as,
        query_os,
        cacheFallback_b,
        getServerData_f : (storageCb_f, storageErrorCb_f) => {
            httpCall_withIdToken_database_f({
                methods_e   : https_methods.GET,
                query_o     : query_os,
                path_as     : path_as.concat(urlSuffix_os.database_json),
                cb_f        : storageCb_f,
                cb_error_f   : storageErrorCb_f
            })
        },
        cb_f : cb_f
    })


}

// http_database_updateData_f
export const http_database_updateData_f = ({path_as, data_c, cb_f}) => {

    httpCall_withIdToken_database_f({
        methods_e   : https_methods.PATCH,
        path_as     : path_as.concat(urlSuffix_os.database_json),
        body_o      : getClassAsObj_f(data_c),
        cb_f        : cb_f
    })

    serverLocalStorage_dataChange_f({
        path_as     : path_as,
        data      : data_c
    })

}

// http_database_updateData_f
export const http_database_setData_f = ({path_as, data_c, currentTime_t = (new Date()).getTime(), cacheFallback_b, retryFailedMsg_b = false, cb_f = ()=>{}}) => {

    const data_o = getClassAsObj_f(data_c)

    const serverReceivedData_b = (data_c && data_c.wsr_serverReceivedData_b) | retryFailedMsg_b

    // add call to failed msg 
    if(serverReceivedData_b){
        const store_failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val
        store_setStateValue(store_var.failedHttpsCalls, {...store_failedHttpsCalls_ao, [currentTime_t] : {path_as, data_c: data_o, currentTime_t, cacheFallback_b, funName_s: "http_database_setData_f"}})
    }

    // set in server
    httpCall_withIdToken_database_f({
        methods_e   : https_methods.PUT,
        path_as     : path_as.concat(urlSuffix_os.database_json),
        body_o      : data_o == null ? {} :  data_o,
        cb_f        : (ans) =>{
            
            //  remove call from failed massages
            if(serverReceivedData_b){
                const store_failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val
                delete store_failedHttpsCalls_ao[currentTime_t]
                store_setStateValue(store_var.failedHttpsCalls, store_failedHttpsCalls_ao)
            }
            cb_f(ans)
        },
    })

    // showLoader for specific message
    if(data_c && data_c.wsr_serverReceivedData_b){
        data_c.wsr_serverReceivedData_b = false
    }

    // update locally
    serverLocalStorage_dataChange_f({path_as, data: data_c, cacheFallback_b})
}

// http_database_pushData_f
export const http_database_pushData_f = ({path_as, data_c, cb_f}) => {

    let data_o = getClassAsObj_f(data_c)

    // set in server
    httpCall_withIdToken_database_f({
        methods_e   : https_methods.POST,
        path_as     : path_as.concat(urlSuffix_os.database_json),
        body_o      : data_o == null ? {} :  data_o,
        cb_f        : cb_f
    })
}

// http_database_getNewKey_f
export const http_database_getNewKey_f = ({path_as, cb_f}) => {

    http_database_pushData_f({
        path_as: path_as,
        data_c : null,
        cb_f : (data_o)=> {
            cb_f(data_o.name)
        }
    })
}

// http_database_transaction_f
export const http_database_transaction_f = ({path_as, updateData_fo, numOfTries_n=3, cb_f, cbFailed_f}) => {

    // get data with ETag
    let transaction_f = () => {

        if(numOfTries_n-- < 1){
            cbFailed_f()
            return
        }

        httpCall_withIdToken_database_f({
            methods_e   : https_methods.GET,
            path_as     : path_as.concat(urlSuffix_os.database_json),
            headers_o   : {
                [http_headers.requestETag] : true
            },
            cb_f        : (data1_o, ETag) => {

                let updatedData = updateData_fo(data1_o != null ? data1_o : {})

                // failed to update
                if(updatedData == null){
                    return
                }

                // setData With ETag
                httpCall_withIdToken_database_f({
                    methods_e   : https_methods.PUT,
                    path_as     : path_as.concat(urlSuffix_os.database_json),
                    body_o      : updatedData,
                    headers_o   : {
                        [http_headers.checkETag] : ETag
                    },
                    cb_f        : (data2_o) => {

                        serverLocalStorage_dataChange_f({
                            path_as : path_as,
                            data    : updatedData
                        })

                        cb_f(data2_o)
                    },
                    cbWrongETag_f(){
                        // try transaction again
                        transaction_f()
                    }
                })

            },
        })
    }

    // call transaction
    transaction_f()


}



// ============== FB Storage ======================
const currentActiveHttpRequest_byFolderPath_b = {}

// http_storage_upload_fp
export const http_storage_uploadFile_f = ({file_c, path_as, dataToSend_ao, retryFailedMsg_b = false, cb_f={}}) => {

    const copyPaths_as = obj_deepCopy_f(path_as)

    if(!isFbFileIsBlobUrl_b(file_c)){
        cb_f(dataToSend_ao)
        return
    }

    file_getFileBlobFromBlobUrl_f(file_c.fi_url_s, (blob_o) => {

        const currentTimeKey_t = (new Date()).getTime()
        const storageBucket_s = path_as.splice(0,1)

        path_as = path_as.concat((new FB_File(file_c)).fi_m_uniqueFullName_s())
        const folderPath_s = `${urls_o.firebasestorage}${storageBucket_s}/o/${createPath_storage_fs(path_as)}`

        //  cache request
        if(retryFailedMsg_b){
            const store_failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val
            store_setStateValue(store_var.failedHttpsCalls, {...store_failedHttpsCalls_ao, [currentTimeKey_t] : {file_c, path_as:copyPaths_as, dataToSend_ao, retryFailedMsg_b, cb_f, funName_s: "http_storage_uploadFile_f"}})
        }

        // request is still active
        if(currentActiveHttpRequest_byFolderPath_b[folderPath_s]){
            return
        }

        currentActiveHttpRequest_byFolderPath_b[folderPath_s] = true

        const prefix_s = "" +
        `--329774601234359649758228124756119` +
        `\nContent-Type: application/json; charset=utf-8` +
        `\nContent-Disposition: form-data; name="metadata"` +
        `\n`+
        `\n{"name":"${createPath_fs(path_as)}", "cacheControl":"max-age=86400","contentType":"${file_c.fi_type_e}"}`+
        `\n--329774601234359649758228124756119`+
        `\nContent-Type: ${file_c.fi_type_e}` +
        `\n\n`

        const suffix_s = '\n--329774601234359649758228124756119--'

        blob_o = new Blob([prefix_s, blob_o, suffix_s])

        file_c.fi_uploadStatus_n = 0.1
        httpCall_withAuthorizationHeader_fp({
            methods_e       : https_methods.POST,
            url_s           : folderPath_s,
            headers_o       : {
                'x-goog-upload-protocol': 'multipart',
                'content-type': 'multipart/related; boundary=329774601234359649758228124756119'
            },
            blob_o,
            cb_onProgress_f : (progress_n) => {
                file_c.fi_uploadStatus_n = progress_n
            },
            cb_f:(fbAns_o)=> {
                currentActiveHttpRequest_byFolderPath_b[folderPath_s] = false
                URL.revokeObjectURL(file_c.fi_url_s);

                const serverFilePath_s = `${folderPath_s}?alt=media&token=${fbAns_o.downloadTokens}`
                file_c.fi_url_s = serverFilePath_s

                // remove cache request
                if(retryFailedMsg_b){
                    const store_failedHttpsCalls_ao = store_getStateValue_vo(store_var.failedHttpsCalls).val
                    delete store_failedHttpsCalls_ao[currentTimeKey_t]
                    store_setStateValue(store_var.failedHttpsCalls, store_failedHttpsCalls_ao)
                }

                cb_f(dataToSend_ao)  
            },
            cb_error_f(){
                currentActiveHttpRequest_byFolderPath_b[folderPath_s] = false
                const a = document.createElement('a');
                a.download = true
                a.href = file_c.fi_url_s
                a.click()   
            }
        })
    })

}

// http_storage_deleteFile_fp
export const http_storage_deleteFile_fp = ({file_c}) => {

    if(file_c.fi_m_isFolder_fb(file_c)){
        return new Promise(resolve => resolve())
    }

    // try to get path from
    let path_as = file_c.fi_url_s.split('/o/')[1].split('?')[0].replace(/%20/g, " ").split('%2F')
    let storageBucket_s = file_c.fi_url_s.split('/b/')[1].split('/o/')[0]

    // path_as = path_as.concat(file_c.fi_uploadDate_t)
    // let storageBucket_s = path_as.splice(0,1)

    let folderPath_s = `${urls_o.firebasestorage}${storageBucket_s}/o/${createPath_storage_fs(path_as)}`

    return httpCall_withAuthorizationHeader_fp({
        methods_e       : https_methods.DELETE,
        url_s           : folderPath_s,
    })
        .then(ans => {
            console.log("ans1", ans)
            return ans
        }).catch(ans => {
            console.log("ans2", ans)

        })


}

// isFbFileIsBlobUrl_b
const isFbFileIsBlobUrl_b = (file_c) => {

    return file_c != null && file_c.fi_url_s != null && file_c.fi_url_s.includes('blob')
}



// ============== translate ======================

// http_translateText_f
export const http_translate_fp = ({textToTranslate_s, targetLang_e}) => {

    return httpRequest_fp({
        methods_e       : https_methods.GET,
        url_s           : `${urls_o.url_translate}?key=${gv_FbConfig().translateKey}&q=${textToTranslate_s}&target=${targetLang_e}`,
        headers_o       : {"Content-Type" : "application/json"},
    }).then(ans => {
        return str_parseString_fs(ans.data.translations[0].translatedText)
    })
}

// http_translate_getLangCode_fp
export const http_translation_detect_fp = ({text_s}) => {

    return httpRequest_fp({
        methods_e       : https_methods.GET,
        url_s           : `${urls_o.url_detectLang}?key=${gv_FbConfig().translateKey}&q=${text_s}`,
        headers_o       : {"Content-Type" : "application/json"},
    }).then(ans => {
        return ans.data.detections[0][0].language
    })
}


// ============== dynamic links ======================

// http_getJsonBody_dynamicLinks_o
export const http_getJsonBody_dynamicLinks_o = (link) => {

    return {
        dynamicLinkInfo: {
            domainUriPrefix: "https://g2gxz.app.goo.gl",
            link: link,
            androidInfo: {
                androidPackageName: "com.travelandquest.pro"
            },
            socialMetaTagInfo: {
                socialTitle       : "Travel Quest Ticket",
                socialDescription : "This is a ticket to quest",
                socialImageLink   : "https://travelquest.xyz/img/icons/logo-full-192x192.png"
            }
        }
    }
}

// http_postRequest_fp
export const http_postRequest_fp = ({url_s, jsonBody_o, cb_f = () => {}, cbError_f = () => {}}) => {


    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", url_s);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onreadystatechange = (e) => {

            if(xhr.readyState === 4) {

                if(xhr.status === 200){
                    let ans_o = JSON.parse(xhr.responseText)
                    cb_f(ans_o)
                    resolve(ans_o)
                }else{

                    let ans_o = xhr.responseText ? JSON.parse(xhr.responseText) : {}
                    cbError_f(ans_o)
                    reject(ans_o)
                }
            }else{
                // console.log(xhr.readyState, xhr.status)
            }
        }

        xhr.send(JSON.stringify(jsonBody_o));

    })
}

// getRequest_fp
export const getRequest_fp = (url_s) => {
    return httpRequest_fp({
        methods_e       : https_methods.GET,
        url_s           : url_s,
    })
}


// ============== helpers ======================

// createPath_fs
const createPath_fs = (path_as) => {
    let url_s = "";
    path_as.forEach((path_s, index_n) => {
        url_s += path_s;
        if(index_n < path_as.length - 1){
            url_s += '/'
        }
    });
    return url_s
}

// createPath_fs
const createPath_storage_fs = (path_as) => {
    let url_s = "";
    path_as.forEach((path_s, index_n) => {
        url_s += path_s;
        if(index_n < path_as.length - 1){
            url_s += '%2F'
        }
    });
    return url_s
}

// createQuery_fs
const createQuery_fs = (query_o) => {

    let objSize_n = obj_size_fn(query_o)
    if(objSize_n === 0){
        return ''
    }

    let query_s = "?";

    obj_forEach_f(query_o, (val, key_n, index_n)=> {

        if(val == null){return}

        query_s += `${key_n}=${val}`
        if(index_n < objSize_n - 1){
            query_s+="&"
        }
    })

    return query_s

}

// getUpdateMask_s
const getUpdateMask_s = (data_o) => {

    let ans = ""
    let keys_as = Object.keys(data_o)


    keys_as.forEach((key, index) => {

        ans += "updateMask.fieldPaths=" + key

        if(index+1 < keys_as.length){
            ans += "&"
        }
    })

    return ans;

}

// parseRealtimeData_fo
const parseRealtimeData_fo = (data_o) => {


    let recFunc_o = (currentNode_o, console_b) => {

        if(!validator_obj_fb(currentNode_o)){
            return currentNode_o
        }


        if(validator_arrayObj_fb(currentNode_o)){
            return Object.values(currentNode_o)
        }


        obj_forEach_f(currentNode_o, (childNode_o, key) => {
            currentNode_o[key] = recFunc_o(childNode_o, key === "qt_history_ac")
        })

        return currentNode_o
    }

    return recFunc_o(data_o)


}

// getClassAsObj0
const getClassAsObj_f = (c) => {

    if(!(c instanceof Object))
        return c;

    let ans = {}
    for(let x in c){

        if(c[x] == null)
            continue;

        if (c[x] instanceof Array){
            ans[x] = c[x].map(item => {
                return getClassAsObj_f(item)
            })
        } else if(c[x] instanceof Object ){
            ans[x] =  getClassAsObj_f(c[x])
        }else{
            ans[x] = c[x]
        }
    }
    return ans;
}

// httpCall_withIdToken_firestore
const httpCall_withAuthorizationHeader_fp = ({methods_e, url_s, headers_o={}, body_o, blob_o, cb_f, cb_onProgress_f, cb_error_f}) => {

    return auth_getIdToken_fp().then( (userIdToken_s) => {

        headers_o["Authorization"] = userIdToken_s != null ? "Bearer " + userIdToken_s : null

        return httpRequest_fp({methods_e, url_s, headers_o, body_o, blob_o, cb_f, cb_onProgress_f, cb_error_f })
    })
}

// httpCall_withIdToken_database
const httpCall_withIdToken_database_f = ({methods_e, path_as, query_o = {}, headers_o, body_o, cb_f= () => {}, cbWrongETag_f= () => {}, cb_error_f=() => {}}) => {

    auth_getIdToken_fp().then( (userIdToken_s) => {

        // add quotes to string query
        let localQuery_o = obj_deepCopy_f(query_o)
        for(let key in localQuery_o){
            if(validator_string_fb(localQuery_o[key])){
                localQuery_o[key] = '"' + localQuery_o[key] + '"'
            }
        }

        localQuery_o.auth = userIdToken_s

        httpRequest_fp({
            methods_e,
            url_s : createPath_fs(path_as) + createQuery_fs(localQuery_o),
            body_o,
            headers_o,
            cb_f,
            cb_error_f,
            cbWrongETag_f,
        })

       
    })
}

// httpRequest_fp
const httpRequest_fp = ({methods_e, url_s, body_o, blob_o, headers_o = {}, tries_n=http_numbers_on.retryFailedMsgNum, cb_f = () => {}, cb_onProgress_f = () => {}, cbWrongETag_f = () => {}, cb_error_f =() => {}}) => {

    const funParams_o = {methods_e, url_s, body_o, blob_o, headers_o, cb_f, cb_onProgress_f, cbWrongETag_f, cb_error_f}

    return new Promise(((resolve, reject) => {

        // open xhr
        const xhr = new XMLHttpRequest()
        xhr.open(methods_e, url_s, true)
        // xhr.timeout = 10000;

        // set headers
        obj_forEach_f(headers_o, (value, key) => {
            if(value != null) {
                xhr.setRequestHeader(key, value);
            }
        });

        // progress
        xhr.upload.onprogress = (event_o) => {
            cb_onProgress_f(event_o.loaded / event_o.total)
        }

        // on ready change
        xhr.onreadystatechange = (e) => {

            if(xhr.readyState === 4) {
                let ans_o = xhr.responseText ? JSON.parse(xhr.responseText) : {}

                switch (xhr.status) {

                    case enum_httpCodes.succeed_n:
                        let ETag;
                        if(headers_o[http_headers.requestETag] != null){
                            ETag = xhr.getResponseHeader(http_headers.responseETag)
                        }
                        cb_f(ans_o, ETag)
                        resolve(ans_o, ETag)
                        break;

                    case enum_httpCodes.succeed_noContent_n:
                        cb_f()
                        resolve()
                        break;

                    case enum_httpCodes.error_client_wrongETag_n:
                    case enum_httpCodes.error_client_NOT_FOUND:
                    case enum_httpCodes.error_client_badRequest_n:
                    case enum_httpCodes.error_server_n:

                        reject(ans_o)
                        cbWrongETag_f(ans_o)
                        break;

                    case enum_httpCodes.error_server_unknown_n:
                        if(tries_n > 0){
                            setTimeout(() => {
                                httpRequest_fp({...funParams_o, tries_n :tries_n-1})
                            }, http_numbers_on.retryFailedMsgWaitTime) 
                        }else{
                            cb_error_f()
                        }
                        break;
                    default :
                        console.log("httpCall_f | default", methods_e, url_s, xhr.status, xhr)

                }
                // xhr.abort();
            }

        }

        // send data
        if(body_o != null){
            xhr.send(JSON.stringify(body_o))
        }else if(blob_o != null){
            xhr.send(blob_o)
        }else{
            xhr.send()
        }

    }))
}

// removeUnnecessaryQueries_fo
const removeUnnecessaryQueries_fo = (query_os) => {


    // delete orderBy if there is no startAt and endAt
    if( query_os[http_queryKeys_os.orderBy] != null &&
        query_os[http_queryKeys_os.startAt] == null &&
        query_os[http_queryKeys_os.endAt] == null &&
        query_os[http_queryKeys_os.equalTo] == null){

        delete query_os[http_queryKeys_os.orderBy]
        delete query_os[http_queryKeys_os.startAt]
        delete query_os[http_queryKeys_os.endAt]
        delete query_os[http_queryKeys_os.equalTo]
    }
}
